module.exports = __webpack_public_path__ + "img/20190610161636140.93c6e580.png";